export default "__VITE_ASSET__BElAFj_z__"